/**
 * DSGVO Cookie Consent Management
 * Version 1.0
 */

const CONSENT_KEY = 'dgd_consent';
const CONSENT_VERSION = '1.0';

export const DEFAULT_CONSENT = {
  version: CONSENT_VERSION,
  necessary: true,
  analytics: false,
  marketing: false,
  updated_at: null
};

/**
 * Get current consent status
 */
export const getConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    
    const consent = JSON.parse(stored);
    
    // Check version - reset if outdated
    if (consent.version !== CONSENT_VERSION) {
      return null;
    }
    
    return consent;
  } catch {
    return null;
  }
};

/**
 * Save consent decision
 */
export const saveConsent = (analytics, marketing) => {
  const consent = {
    version: CONSENT_VERSION,
    necessary: true,
    analytics: analytics,
    marketing: marketing,
    updated_at: new Date().toISOString()
  };
  
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  
  // Trigger custom event for listeners
  window.dispatchEvent(new CustomEvent('consentUpdated', { detail: consent }));
  
  return consent;
};

/**
 * Accept all cookies
 */
export const acceptAll = () => {
  return saveConsent(true, true);
};

/**
 * Accept only necessary
 */
export const acceptNecessaryOnly = () => {
  return saveConsent(false, false);
};

/**
 * Check if specific consent is given
 */
export const hasConsent = (category) => {
  const consent = getConsent();
  
  if (!consent) return false;
  
  // Necessary is always true
  if (category === 'necessary') return true;
  
  return consent[category] === true;
};

/**
 * Clear consent (for testing/reset)
 */
export const clearConsent = () => {
  localStorage.removeItem(CONSENT_KEY);
  window.dispatchEvent(new CustomEvent('consentUpdated', { detail: null }));
};
